<div class="header list-header d-flex d-md-block align-items-center">
  <h1 class="d-block d-md-inline-block v-align-middle">{{title | translate}}</h1>
  @if (allowNew) {
    <button class="btn btn-outlined btn-list-header" (click)="onCreateItem()">
      <img src="assets/icons/plus-darker.svg" alt="create" />{{'CREATE_BTN' | translate}}
    </button>
  }
</div>
@if (allowOpenOnRowClick) {
  <app-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [itemsSource]="itemsSource"
    [preferencesKey]="preferencesKey"
    (rowClick)="onRowClicked($event)"
    >
  </app-list-view>
}

@if (!allowOpenOnRowClick) {
  <app-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="contextMenuDefinition"
    [itemsSource]="itemsSource"
    [preferencesKey]="preferencesKey"
    >
  </app-list-view>
}
